import icon from 'assets/img/icons/icon-warning.svg'

const AddFundsPopupFail = ({close}) => {
  return (
    <>
      <header className="modal-window__header">
        <img src={icon} className="modal-window__icon" alt="" />
        <h5 className="modal-window__title">Sorry!</h5>
        <p className="modal-window__info">The withdrawal couldn’t be processed at this time. Please try again in a few minutes or contact Support.</p>
      </header>
      <footer className="modal-window__footer">
        <button className="modal-window__footer-submit" onClick={close}>Continue</button>
      </footer>
    </>
  )
}

export default AddFundsPopupFail;
